var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.333 2.5a1.5 1.5 0 0 0-1.5 1.5v9.084l2.815-1.81a2.5 2.5 0 0 1 2.704 0l2.815 1.81V4a1.5 1.5 0 0 0-1.5-1.5H5.333ZM2.833 4a2.5 2.5 0 0 1 2.5-2.5h5.334a2.5 2.5 0 0 1 2.5 2.5v10a.5.5 0 0 1-.77.42L8.81 12.117a1.5 1.5 0 0 0-1.622 0L3.604 14.42a.5.5 0 0 1-.77-.421V4Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmark);
export default ForwardRef;